import React, { FC } from 'react';
import { SLOT_PANEL } from 'components/ads/ad-slot/ad-defs';
import AdSlotPlaceholderGAM from 'components/ads/ad-slot-placeholder-gam';
import AdSlot from 'components/ads/ad-slot';

import './ad-slot-panel.scss';

const AdSlotPanel: FC = () => (
    <AdSlotPlaceholderGAM className="ad-slot-panel">
        <AdSlot name={SLOT_PANEL} />
    </AdSlotPlaceholderGAM>
);

export default AdSlotPanel;
